import {Fragment} from 'react/jsx-runtime';
import styled from 'styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles';

interface IProps {
  text: string;
  query: string;
  highlightColor?: string;
}

export const HighlightText = ({text, query, highlightColor}: IProps) => {
  if (!text?.length) {
    return null;
  }

  const tokenized = text.split(query);
  const out: any = [];

  tokenized.forEach((str, i) => {
    out.push(<Fragment key={`${text}-${query}-${str}-${i}-1`}>{str}</Fragment>);
    if (i < tokenized.length - 1) {
      out.push(
        <SearchText
          key={`${text}-${query}-${str}-${i}-2`}
          color={highlightColor}
        >
          {query}
        </SearchText>
      );
    }
  });

  return <>{out}</>;
};

const SearchText = styled('span').withConfig({
  shouldForwardProp: interceptProps(['color']),
})<{
  color?: string;
}>`
  color: ${({color}) => color ?? palette.blue400};
`;
